import { styled } from "@mui/material";

const StyledHelperText = styled("span", {
  shouldForwardProp: (propName) => propName !== "error"
})<{
  error?: boolean;
}>(
  ({ theme, error }) => `
  width: 100%;
  color: ${error ? theme.palette.error.main : theme.palette.text.secondary};
  font-weight: bold;
  margin: 3px 0;
`
);
export default StyledHelperText;
